import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";

import Toast from "light-toast";
function InitialModal(props) {
  const [initials, setInitials] = useState("");
  const [fullName, setFullname] = useState("");

  const handleModal = () => {
    if (
      props?.values?.initials === "" ||
      props?.values?.initials === undefined
    ) {
      Toast.fail("Please fill initails", 500);
    } else if (
      props?.values?.fullName === "" ||
      props?.values?.fullName === undefined
    ) {
      Toast.fail("Please fill fullname", 500);
    } else {

      Toast.success("Submitted", 300);
      clearFields();
      setInitials("");
      setFullname("");
    }
  };

  const clearFields = () => {
    props.setPasswordModal(false);
    // props.setInitialValues({ initials: "", fullName: "" });
  };

  return (
    <div>
      <Modal className="initial-model" show={props.show} centered>
        <button className="remove_initial_modal" onClick={() => clearFields()}>
          <svg width="25" height="25" viewBox="0 0 25 25">
            <g transform="translate(-680 -168)">
              <circle
                style={{ fill: "#4E74F6" }}
                cx="12.5"
                cy="12.5"
                r="12.5"
                transform="translate(680 168)"
              />
              <g transform="translate(687.243 156.151) rotate(45)">
                <path
                  style={{
                    fill: "none",
                    stroke: "#fff",
                    strokeLinecap: "square",
                    strokeWidth: "1.3px",
                  }}
                  d="M27,11H14"
                  transform="translate(0 2.5)"
                />
                <path
                  style={{
                    fill: "none",
                    stroke: "#fff",
                    strokeLinecap: "square",
                    strokeWidth: "1.3px",
                  }}
                  d="M18,7V20"
                  transform="translate(2.5 0)"
                />
              </g>
            </g>
          </svg>
        </button>

        <div className="intial_form">
          <div className="form-group" style={{ margin: "0 0 20px" }}>
            <label htmlFor="exampleInputEmail1" className="initial_lable ">
              Initials
            </label>
            <input
              type="text"
              value={initials}
              className="form-control intial_textbox"
              id="exampleInputEmail1"
              placeholder="Enter initials"
              {...props.bindField("initials")}
              autoComplete="off"
              required
            />
            {/* {props.errors?.initials} */}
          </div>
          <div className="form-group" style={{ margin: "0 0 20px" }}>
            <label htmlFor="exampleInputPassword1" className="initial_lable ">
              Fullname
            </label>
            <input
              type="text"
              value={fullName}
              className="form-control intial_textbox"
              id="exampleInputEmail1"
              placeholder="Enter full name"
              {...props.bindField("fullName")}
        
              autoComplete="off"
              required
            />
           
            {/* {props.errors?.fullName} */}
          </div>
        </div>

        {/* <Button variant="secondary">Close</Button> */}
        <Button
          variant="primary"
          className="save-intials"
          onClick={() => handleModal()}
        >
          Save
        </Button>
      </Modal>
    </div>
  );
}

export default InitialModal;
